import { themed } from "@smartsheet/sds-theme-internal";
import { blanketBackground } from "../../../constants/colors";
export var blanketTheme = themed({
  background: {
    "lodestar-light": blanketBackground,
    // TODO use the official color token for this at some point.
    "ursa-light": "rgba(36, 39, 50, 0.08)"
  }
});
export function getBackground(_ref) {
  var themeMode = _ref.themeMode;
  return blanketTheme.background(themeMode);
}
//# sourceMappingURL=blanketTheme.js.map